<template>
  <!-- <b-card-code title=""> -->
    <b-tabs pills>
     <b-tab
        title="Oustanding"
        active
      >

      <IndexNotYetPayment />
      </b-tab>
      <b-tab
        title="List Create"
      >

      <IndexPayment />
      </b-tab>
    </b-tabs>
  <!-- </b-card-code> -->
</template>
<script>
// import BCardCode from '@core/components/b-card-code'
import { BTabs,BTab } from 'bootstrap-vue'
import IndexNotYetPayment from './indexNotYetPayment.vue'
import IndexPayment from './indexPayment.vue'

// BTabs, BCardText
export default {
  components: {
    // BCardCode,
    BTabs,
    BTab,
    IndexNotYetPayment,
    IndexPayment
  },
  data () {
    return {
      options: {}
    }
  }
}

</script>
